// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.254 10.47L9.88398 2.08801L11.817 2.60601L14.627 11.641L19.888 13.051C20.0783 13.102 20.2567 13.1899 20.413 13.3098C20.5693 13.4297 20.7004 13.5792 20.7989 13.7498C20.8975 13.9204 20.9614 14.1087 20.9872 14.304C21.0129 14.4993 20.9999 14.6977 20.949 14.888C20.898 15.0783 20.8101 15.2567 20.6902 15.413C20.5703 15.5693 20.4208 15.7004 20.2502 15.799C20.0796 15.8975 19.8913 15.9615 19.696 15.9872C19.5007 16.0129 19.3023 16 19.112 15.949L4.13998 11.937L4.91598 9.03901L5.15798 9.10401L6.07198 12.454L3.44498 11.751C3.22972 11.6931 3.03998 11.5649 2.90591 11.3868C2.77184 11.2087 2.70112 10.9909 2.70498 10.768L2.79498 5.36501L4.24398 5.75301L5.15798 9.10401L10.254 10.47V10.47ZM3.99998 19H20V21H3.99998V19Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
